import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import s from './About.css';
import messages from '../../../locale/messages';
import { isRTL } from '../../../helpers/formatLocale';

import msLogo from '../../../../images/new-landing/MS.png';

class About extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
  };

  state = {
    scrollProgress: 0,
  };

  aboutSectionRef = React.createRef();

  componentDidMount() {
    if (typeof window === 'undefined') return;

    window.addEventListener('scroll', this.updateHighlight, { passive: true });
    this.updateHighlight();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.intl.locale !== this.props.intl.locale) {
      this.updateHighlight();
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.updateHighlight);
    }
  }

  updateHighlight = () => {
    const aboutSection = this.aboutSectionRef.current;
    if (!aboutSection) return;

    const rect = aboutSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    let progress = (windowHeight - rect.top) / (rect.height || 1);
    progress = Math.max(0, Math.min(1, progress - 0.2));

    if (progress !== this.state.scrollProgress) {
      this.setState({ scrollProgress: progress });
    }
  };

  render() {
    const { intl } = this.props;
    const { scrollProgress } = this.state;
    const rtl = isRTL(intl.locale);
    const text = intl.formatMessage(messages.newLandingAbout);
    const words = text.split(/\s+/).filter(word => word.length > 0);

    return (
      <section id="about" ref={this.aboutSectionRef} className={s.aboutSection}>
        <div className={s.aboutLogoIcon}>
          <img src={msLogo} alt={intl.formatMessage(messages.newLandingMsLogoAlt)} />
        </div>
        <div
          className={s.scrollTextContainer}
          dir={rtl ? 'rtl' : 'ltr'}
        >
          {words.map((word, index) => {
            const threshold = index / words.length;
            const isActive = scrollProgress > threshold;

            return (
              <span
                key={`${intl.locale}-${index}`}
                className={cx(s.scrollWord, isActive && s.scrollWordActive)}
              >
                {word}
                {'\u00A0'}
              </span>
            );
          })}
        </div>
      </section>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
)(About);
